import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { returnFalse, returnTrue } from '@ardoq/common-helpers';
import { focusedChrome$ } from 'scope/focusedChrome$';
import { focusedChromeOperations } from 'scope/focusedChromeOperations';
import { closePane, splitPane } from './actions';

const isSplitPaneRequested$ = persistentReducedStream<boolean>(
  'isSplitPaneRequested$',
  false,
  [
    reducer<boolean>(splitPane, returnTrue),
    reducer<boolean>(closePane, returnFalse),
  ]
);

/**
 * Focused chrome offers one visualization and no control to close a second
 * pane. A split is refused there rather than closed after the fact: requests
 * also arrive from a route carrying a secondary view, and without the control
 * the user could not undo one.
 *
 * The request itself is kept, so leaving focused chrome restores the split the
 * user last chose.
 */
export const isSplitPane$ = combineLatest([
  isSplitPaneRequested$,
  focusedChrome$,
]).pipe(
  map(
    ([isSplitPaneRequested, focusedChrome]) =>
      isSplitPaneRequested &&
      !focusedChromeOperations.isFocusedChrome(focusedChrome)
  ),
  distinctUntilChanged()
);
